import React from 'react';
import Icon from '@uiw/react-icon';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Card = props => {
  var {
    className,
    prefixCls = 'w-fileinput-card',
    dataList = [],
    maxNumber = 3,
    shape = 'round',
    size = 'middle',
    readonly,
    children,
    showFileIcon = {
      showPreviewIcon: true,
      showRemoveIcon: true
    },
    onAdd,
    onPreview,
    onRemove
  } = props;
  var cls = [prefixCls, prefixCls + "-size-" + size, prefixCls + "-shape-" + shape, className].filter(Boolean).join(' ').trim();
  var isAction = showFileIcon.showPreviewIcon || showFileIcon.showRemoveIcon ? true : false;
  return /*#__PURE__*/_jsxs("div", {
    className: cls,
    children: [dataList.map((item, index) => /*#__PURE__*/_jsxs("div", {
      className: prefixCls + "-box",
      children: [/*#__PURE__*/_jsx("div", {
        className: prefixCls + "-box-info",
        children: /*#__PURE__*/_jsx("img", {
          src: item['dataURL'],
          alt: ""
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: isAction ? prefixCls + "-actions" : '',
        children: [(showFileIcon == null ? void 0 : showFileIcon.showPreviewIcon) && /*#__PURE__*/_jsx("span", {
          className: prefixCls + "-actions-remove",
          onClick: () => onPreview == null ? void 0 : onPreview(item),
          children: /*#__PURE__*/_jsx(Icon, {
            type: "search",
            style: {
              color: '#fff',
              fontSize: 16
            }
          })
        }), (showFileIcon == null ? void 0 : showFileIcon.showRemoveIcon) && /*#__PURE__*/_jsx("span", {
          className: prefixCls + "-actions-remove",
          onClick: () => onRemove == null ? void 0 : onRemove(index),
          children: /*#__PURE__*/_jsx(Icon, {
            type: "delete",
            style: {
              color: '#fff',
              fontSize: 16
            }
          })
        })]
      })]
    }, index)), maxNumber > dataList.length && !readonly && /*#__PURE__*/_jsx("div", {
      className: prefixCls + "-box " + prefixCls + "-btn",
      onClick: onAdd,
      children: children
    })]
  });
};
export default Card;